// Translation dictionary for React web application
const translations = {
  // Amharic translations
  am: {
    welcome: '🙏 <b>እንኳን ደህና መጡ!</b>\n\nይህ ድህረ ገጽ የኢትዮጵያ ኦርቶዶክስ ተዋሕዶ ቤተክርስቲያን የዕለት ንባብ (ግጽዌ እና ስንክሳር) ያቀርባል።\n\n✅ <b>አሁን ተመዝግበዋል!</b> በየቀኑ ጠዋት 6:00 ሰዓት የዕለቱ ንባብ ይላክልዎታል።\n\n<b>📱 ዋና ትዕዛዞች:</b>\n/today - የዛሬ ንባብ\n/yesterday - የትናንት ንባብ\n/tomorrow - የነገ ንባብ\n/subscribe - ለዕለታዊ ንባብ ለመመዝገብ\n/unsubscribe - ምዝገባን ለመሰረዝ\n/subscribe_channel - ቻናልን ለመመዝገብ\n/status - የቦት ሁኔታ\n/help - ሙሉ እርዳታ',
    
    help: '📚 <b>የእርዳታ መረጃ</b>\n\n<b>🤖 ስለ ቦቱ:</b>\nይህ ቦት የኢትዮጵያ ኦርቶዶክስ ተዋሕዶ ቤተክርስቲያን የዕለት ንባብ ያቀርባል።\n\n<b>📖 ግጽዌ:</b> የዕለቱ የመጽሐፍ ቅዱስ ንባብ\n<b>📜 ስንክሳር:</b> የቅዱሳን ታሪክ እና ትዝታ\n\n<b>📱 ዋና ትዕዛዞች:</b>\n/start - ለመመዝገብ እና ቦቱን ለመጀመር\n/today - የዛሬ ንባብ ለማግኘት\n/yesterday - የትናንት ንባብ ለማግኘት\n/tomorrow - የነገ ንባብ ለማግኘት\n/subscribe - ለዕለታዊ ንባብ ለመመዝገብ (ግል ቻት)\n/unsubscribe - ምዝገባን ለመሰረዝ (ግል ቻት)\n/subscribe_channel - ቻናልን ለመመዝገብ (ቻናሎች/ቡድኖች)\n/status - የቦት እና የምዝገባ ሁኔታ\n\n<b>⏰ የዕለታዊ ንባብ ጊዜ:</b>\nበየቀኑ ጠዋት 6:00 ሰዓት (የኢትዮጵያ ሰዓት)',
    
    language_menu: '🌐 <b>የቋና ምርጫ።</b>\n\nእባክዎ የሚፈልጉትን ቋንቋን ይምረጡ:\n\n🇪🇹 /lang_am - አማርኛ\n🇺🇸 /lang_en - English\n🇪🇹 /lang_gez - ግዕዝ\n\nየቦቱ ሁሉንም መልእክቶች በምርጫቸው ቋንቋ ይላኩላታል።',
    
    language_set: '✅ <b>ቋና ተቀየረ!</b>\n\nአሁን የቦቱ ቋና: {{lang}}\n\nየቦቱ እይታኖች በዚህ ቋና ይታያሉ።',
    
    no_readings: '📅 <b>የዛሬ ኢትዮጵያ ቀን:</b> {{date}}\n\n🙏 <b>ለዚህ ቀን ንባብ አልተገኘም።</b>\n\n📖 <b>ግጽዌ:</b> የዕለቱ የመጽሐፍ ቅዱስ ንባብ\n📜 <b>ስንክሳር:</b> የቅዱሳን ታሪክ\n\n💭 <b>የዕለቱ ጥቅስ:</b>\n<i>"እግዚአብሔር ፍቅር ነው፤ በፍቅርም የሚኖር በእግዚአብሔር ይኖራል፥ እግዚአብሔርም በእርሱ ይኖራል።"</i>\n<code>1ኛ ዮሐንስ 4:16</code>',
    
    error: '⚠️ ስህተት ተከስቷል። እባክዎ ዳግም ይሞክሩ።',
    
    unknown_command: '🙏 <b>እንኳን ደህና መጡ!</b>\n\nየላክልኝን መልእክት ተቀብያለሁ: "<i>{{text}}</i>"\n\n/help ን በመጠቀም የምችላቸውን ነገሮች ማየት ይችላሉ።',
    
    // Web-specific translations
    navigation: {
      home: 'ቤት',
      readings: 'ንባቦች',
      about: 'ስለ',
      contact: 'አግኙን',
      calendar: 'ቀን መቁጠሪያ'
    },
    
    buttons: {
      read_more: 'ተጨማማ ያንብቡ',
      subscribe: 'ይመዝገቡ',
      unsubscribe: 'ይሰርዙ',
      share: 'ያጋሩ',
      copy: 'ቅጂ',
      download: 'አውርዱ',
      daily_prayer: 'የዘወትር ጸሎት',
      wudasie: 'የ{{day}} ውዳሴ ማርያም',
      anqetsa_birhan: 'አንቀጸ ብርሃን',
      yewedeswa_melak: 'ይወድስዋ መላእክት',
      melka_mariam: 'መልክዐ ማርያም',
      melka_jesus: 'መልክዐ ኢየሱስ',
      gitsawe: 'ግጻዌ',
      sinksar: 'ስንክሳር'
    },
    
    labels: {
      todays_reading: 'የዛሬ ንባብ',
      ethiopian_date: 'የኢትዮጵያ ቀን',
      gregorian_date: 'ግሪጎሪያን ቀን',
      language: 'ቋና',
      theme: 'ገጽባሪ',
      search: 'ፈልግ'
    },
    sidebar: {
      title: 'በኢትዮጵያ ኦርቶዶክስ ተዋህዶ',
      subtitle: 'ለአገልግሎት ከምንጠቀምባቸው የተወሰኑት',
      sinksar: 'ስንክሳር', bahirehasab: 'ባሕረ ሃሳብ', gitsawe: 'ግጻዌ',
      wudasie: 'ውዳሴ ማርያም', bible: 'መጽሐፍ ቅዱስ', seatat: 'ሰአታት',
      hibuat: 'በእንተ ትምኅርተ ኅቡዓት', books: 'መጻሕፍት', mahlet: 'ሥርዓተ ማኅሌት',
      filseta: 'እትዓመነኪ እና መልክዐ ፍልሰታ', news: 'ዜናዎች', posting: 'ልጥፍ አትም',
      admin: 'አስተዳዳሪ', bookmarks: 'የእኔ ምርጦች', notes: 'የግል ማስታወሻዎች',
      projects: 'ፕሮጀክቶቼ',
      support_title: 'ድጋፍ ያድርጉን', support_note: 'የእናንተ ድጋፍ ይህንን አገልግሎት ለማስቀጠል ይረዳናል'
    }
  },
  
  // English translations
  en: {
    welcome: '🙏 <b>Welcome!</b>\n\nThis website provides daily Ethiopian Orthodox Tewahedo Church readings (Gitsawe and Sinksar).\n\n✅ <b>Successfully subscribed!</b> You will receive daily readings at 6:00 AM.\n\n<b>📱 Main Commands:</b>\n/today - Today\'s reading\n/yesterday - Yesterday\'s reading\n/tomorrow - Tomorrow\'s reading\n/subscribe - Subscribe to daily readings\n/unsubscribe - Unsubscribe\n/subscribe_channel - Subscribe channel\n/status - Bot status\n/help - Full help',
    
    help: '📚 <b>Help Information</b>\n\n<b>🤖 About the Bot:</b>\nThis bot provides daily Ethiopian Orthodox Tewahedo Church readings.\n\n<b>📖 Gitsawe:</b> Daily scripture readings\n<b>📜 Sinksar:</b> Saints\' history and memories\n\n<b>📱 Main Commands:</b>\n/start - Subscribe and start bot\n/today - Get today\'s reading\n/yesterday - Get yesterday\'s reading\n/tomorrow - Get tomorrow\'s reading\n/subscribe - Subscribe to daily readings (private)\n/unsubscribe - Unsubscribe (private)\n/subscribe_channel - Subscribe channel (channels/groups)\n/status - Bot and subscription status\n\n<b>⏰ Daily Reading Time:</b>\nEvery day at 6:00 AM (Ethiopian time)',
    
    language_menu: '🌐 <b>Language Selection</b>\n\nPlease select your preferred language:\n\n🇪🇹 /lang_am - አማርኛ\n🇺🇸 /lang_en - English\n🇪🇹 /lang_gez - ግዕዝ\n\nAll bot responses will appear in your selected language.',
    
    language_set: '✅ <b>Language Changed!</b>\n\nBot language is now: {{lang}}\n\nBot responses will appear in this language.',
    
    no_readings: '📅 <b>Today\'s Ethiopian Date:</b> {{date}}\n\n🙏 <b>No readings found for this day.</b>\n\n📖 <b>Gitsawe:</b> Daily scripture reading\n📜 <b>Sinksar:</b> Saints\' history\n\n💭 <b>Daily Quote:</b>\n<i>"God is love, and whoever abides in love abides in God, and God abides in him."</i>\n<code>1 John 4:16</code>',
    
    error: '⚠️ An error occurred. Please try again.',
    
    unknown_command: '🙏 <b>Welcome!</b>\n\nI received your message: "<i>{{text}}</i>"\n\nUse /help to see what I can do.',
    
    // Web-specific translations
    navigation: {
      home: 'Home',
      readings: 'Readings',
      about: 'About',
      contact: 'Contact',
      calendar: 'Calendar'
    },
    
    buttons: {
      read_more: 'Read More',
      subscribe: 'Subscribe',
      unsubscribe: 'Unsubscribe',
      share: 'Share',
      copy: 'Copy',
      download: 'Download',
      daily_prayer: 'Daily Prayer',
      wudasie: 'Wudasie Maryam',
      anqetsa_birhan: 'Anqetsa Birhan',
      yewedeswa_melak: 'Yewedeswa Melak',
      melka_mariam: 'Melka Mariam',
      melka_jesus: 'Melka Jesus',
      gitsawe: 'Gitsawe',
      sinksar: 'Sinksar'
    },
    
    labels: {
      todays_reading: 'Today\'s Reading',
      ethiopian_date: 'Ethiopian Date',
      gregorian_date: 'Gregorian Date',
      language: 'Language',
      theme: 'Theme',
      search: 'Search'
    },
    sidebar: {
      title: 'Ethiopian Orthodox Tewahedo',
      subtitle: 'Selected liturgical resources',
      sinksar: 'Sinksar', bahirehasab: 'Bahire Hasab', gitsawe: 'Gitsawe',
      wudasie: 'Wudasie Mariam', bible: 'Holy Bible', seatat: 'Seatat',
      hibuat: 'Hibuat', books: 'Books', mahlet: 'Mahlet',
      filseta: 'Filseta', news: 'News', posting: 'Post',
      admin: 'Admin', bookmarks: 'My Bookmarks', notes: 'My Notes',
      projects: 'My Projects',
      support_title: 'Support Our Ministry', support_note: 'Your support helps us continue this service'
    }
  },
  
  // Ge'ez translations
  gez: {
    welcome: '🙏 <b>እንኳን ደህና መጡ!</b>\n\nይህ ድህረ ገጽ የኢትዮጵያ ኦርቶዶክስ ተዋሕዶ ቤተክርስቲያን የዕለት ንባብ (ግጽዌ እና ስንክሳር) ያቀርባል።\n\n✅ <b>አሁን ተመዝግበዋል!</b> በየቀኑ ጠዋት 6:00 ሰዓት የዕለቱ ንባብ ይላክልዎታል።\n\n<b>📱 ዋና ትዕዛዞች:</b>\n/today - የዛሬ ንባብ\n/yesterday - የትናንት ንባብ\n/tomorrow - የነገ ንባብ\n/subscribe - ለዕለታዊ ንባብ ለመመዝገብ\n/unsubscribe - ምዝገባን ለመሰረዝ\n/subscribe_channel - ቻናልን ለመመዝገብ\n/status - የቦት ሁኔታ\n/help - ሙሉ እርዳታ',
    
    help: '📚 <b>የእርዳታ መረጃ</b>\n\n<b>🤖 ስለ ቦቱ:</b>\nይህ ቦት የኢትዮጵያ ኦርቶዶክስ ተዋሕዶ ቤተክርስቲያን የዕለት ንባብ ያቀርባል።\n\n<b>📖 ግጽዌ:</b> የዕለቱ የመጽሐፍ ቅዱስ ንባብ\n<b>📜 ስንክሳር:</b> የቅዱሳን ታሪክ እና ትዝታ\n\n<b>📱 ዋና ትዕዛዞች:</b>\n/start - ለመመዝገብ እና ቦቱን ለመጀመር\n/today - የዛሬ ንባብ ለማግኘት\n/yesterday - የትናንት ንባብ ለማግኘት\n/tomorrow - የነገ ንባብ ለማግኘት\n/subscribe - ለዕለታዊ ንባብ ለመመዝገብ (ግል ቻት)\n/unsubscribe - ምዝገባን ለመሰረዝ (ግል ቻት)\n/subscribe_channel - ቻናልን ለመመዝገብ (ቻናሎች/ቡድኖች)\n/status - የቦት እና የምዝገባ ሁኔታ\n\n<b>⏰ የዕለታዊ ንባብ ጊዜ:</b>\nበየቀኑ ጠዋት 6:00 ሰዓት (የኢትዮጵያ ሰዓት)',
    
    language_menu: '🌐 <b>የቋና ምርጫ።</b>\n\nእባክዎ የሚፈልጉትን ቋንቋን ይምረጡ:\n\n🇪🇹 /lang_am - አማርኛ\n🇺🇸 /lang_en - English\n🇪🇹 /lang_gez - ግዕዝ\n\nየቦቱ ሁሉንም መልእክቶች በምርጫቸው ቋንቋ ይላኩላታል።',
    
    language_set: '✅ <b>ቋና ተቀየረ!</b>\n\nአሁን የቦቱ ቋና: {{lang}}\n\nየቦቱ እይታኖች በዚህ ቋና ይታያሉ።',
    
    no_readings: '📅 <b>የዛሬ ኢትዮጵያ ቀን:</b> {{date}}\n\n🙏 <b>ለዚህ ቀን ንባብ አልተገኘም።</b>\n\n📖 <b>ግጽዌ:</b> የዕለቱ የመጽሐፍ ቅዱስ ንባብ\n📜 <b>ስንክሳር:</b> የቅዱሳን ታሪክ\n\n💭 <b>የዕለቱ ጥቅስ:</b>\n<i>"እግዚአብሔር ፍቅር ነው፤ በፍቅርም የሚኖር በእግዚአብሔር ይኖራል፥ እግዚአብሔርም በእርሱ ይኖራል።"</i>\n<code>1ኛ ዮሐንስ 4:16</code>',
    
    error: '⚠️ ስህተት ተከስቷል። እባክዎ ዳግም ይሞክሩ።',
    
    unknown_command: '🙏 <b>እንኳን ደህና መጡ!</b>\n\nየላክልኝን መልእክት ተቀብያለሁ: "<i>{{text}}</i>"\n\n/help ን በመጠቀም የምችላቸውን ነገሮች ማየት ይችላሉ።',
    
    // Web-specific translations
    navigation: {
      home: 'ቤት',
      readings: 'ንባቦች',
      about: 'ስለ',
      contact: 'አግኙን',
      calendar: 'ቀን መቁጠሪያ'
    },
    
    buttons: {
      read_more: 'ተጨማማ ያንብቡ',
      subscribe: 'ይመዝገቡ',
      unsubscribe: 'ይሰርዙ',
      share: 'ያጋሩ',
      copy: 'ቅጂ',
      download: 'አውርዱ',
      daily_prayer: 'የዘወትር ጸሎት',
      wudasie: 'የ{{day}} ውዳሴ ማርያም',
      anqetsa_birhan: 'አንቀጸ ብርሃን',
      yewedeswa_melak: 'ይወድስዋ መላእክት',
      melka_mariam: 'መልክዐ ማርያም',
      melka_jesus: 'መልክዐ ኢየሱስ',
      gitsawe: 'ግጻዌ',
      sinksar: 'ስንክሳር'
    },
    
    labels: {
      todays_reading: 'የዛሬ ንባብ',
      ethiopian_date: 'የኢትዮጵያ ቀን',
      gregorian_date: 'ግሪጎሪያን ቀን',
      language: 'ቋና',
      theme: 'ገጽባሪ',
      search: 'ፈልግ'
    },
    sidebar: {
      title: 'በኢትዮጵያ ኦርቶዶክስ ተዋህዶ',
      subtitle: 'ለአገልግሎት ከምንጠቀምባቸው የተወሰኑት',
      sinksar: 'ስንክሳር', bahirehasab: 'ባሕረ ሃሳብ', gitsawe: 'ግጻዌ',
      wudasie: 'ውዳሴ ማርያም', bible: 'መጽሐፍ ቅዱስ', seatat: 'ሰአታት',
      hibuat: 'በእንተ ትምኅርተ ኅቡዓት', books: 'መጻሕፍት', mahlet: 'ሥርዓተ ማኅሌት',
      filseta: 'እትዓመነኪ እና መልክዐ ፍልሰታ', news: 'ዜናዎች', posting: 'ልጥፍ አትም',
      admin: 'አስተዳዳሪ', bookmarks: 'የእኔ ምርጦች', notes: 'የግል ማስታወሻዎች',
      projects: 'ፕሮጀክቶቼ',
      support_title: 'ድጋፍ ያድርጉን', support_note: 'የእናንተ ድጋፍ ይህንን አገልግሎት ለማስቀጠል ይረዳናል'
    }
  }
};

// Get translation by key and language with parameter support
export const getTranslation = (key, language = 'am', params = {}) => {
  const langTranslations = translations[language] || translations['am'];
  
  // Handle nested keys (e.g., 'navigation.home')
  const keys = key.split('.');
  let translation = langTranslations;
  
  for (const k of keys) {
    translation = translation?.[k];
    if (!translation) break;
  }
  
  // Fallback to Amharic if translation not found
  if (!translation && language !== 'am') {
    const amharicTranslations = translations['am'];
    translation = amharicTranslations;
    for (const k of keys) {
      translation = translation?.[k];
      if (!translation) break;
    }
  }
  
  // Return key if no translation found
  if (!translation) {
    return key;
  }
  
  // Replace parameters in translation
  let result = translation;
  for (const [param, value] of Object.entries(params)) {
    result = result.replace(new RegExp(`{{${param}}}`, 'g'), value);
  }
  
  return result;
};

// Get available languages
export const getAvailableLanguages = () => [
  { code: 'am', name: 'አማርኛ', flag: '🇪🇹' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'gez', name: 'ግዕዝ', flag: '🇪🇹' }
];

// Validate language code
export const isValidLanguage = (code) => {
  return ['am', 'en', 'gez'].includes(code);
};

export default translations;
